//  NOTE we can get "null" from the backend in various forms. One interesting
//  case is '--' which the backend uses to work around nulls in DynamoDB.
export default (value: unknown): boolean =>
  value !== undefined &&
  value !== null &&
  value !== '--' &&
  value !== '- -' &&
  value !== '' &&
  !Number.isNaN(value);
